(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-slack-wholesale"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SLACK_HOST = 'hooks.slack.com';

  function fieldValue(form, name) {
    var field = form.elements.namedItem(name);
    if (!field || typeof field.value !== 'string') return '';
    return field.value.trim();
  }

  function escapeSlack(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function isSlackWebhook(url) {
    try {
      var parsed = new URL(url);
      return parsed.protocol === 'https:' && parsed.hostname === SLACK_HOST;
    } catch (error) {
      return false;
    }
  }

  function showSuccess(form) {
    var fields = form.querySelector('[data-slack-fields]');
    var success = form.querySelector('[data-slack-success]');
    if (fields) fields.hidden = true;
    if (success) {
      success.hidden = false;
      var status = success.querySelector('[data-form-status]');
      if (status) status.focus();
    }
  }

  function showError(form) {
    var error = form.querySelector('[data-slack-error]');
    if (error) error.hidden = false;
  }

  function onSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var error = form.querySelector('[data-slack-error]');
    if (error) error.hidden = true;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var honeypot = form.querySelector('[data-slack-honeypot]');
    if (honeypot && honeypot.value) {
      showSuccess(form);
      return;
    }

    var webhookUrl = form.getAttribute('data-webhook-url');
    if (!isSlackWebhook(webhookUrl)) {
      showError(form);
      return;
    }

    var name = fieldValue(form, 'contact[author]');
    var email = fieldValue(form, 'contact[email]');
    var message = fieldValue(form, 'contact[body]').slice(0, 2500);
    var username = form.getAttribute('data-slack-username');
    var text = [
      '*:briefcase: New B2B Inquiry :briefcase:*',
      '*Name:* ' + escapeSlack(name),
      '*Email:* ' + escapeSlack(email),
      '*Page:* <' + window.location.href + '|View page>',
      '*Message:*',
      escapeSlack(message)
    ].join('\n');

    var payload = {
      text: 'New contact form message from ' + name,
      unfurl_links: false,
      unfurl_media: false,
      blocks: [
        {
          type: 'section',
          text: { type: 'mrkdwn', text: text }
        }
      ]
    };

    if (username) payload.username = username;

    var body = new URLSearchParams();
    body.set('payload', JSON.stringify(payload));

    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    /*
      Slack incoming webhooks do not send CORS headers. A form-encoded
      payload POST is a simple request, so the browser can send it.
      The response is opaque and a bad webhook still looks successful.
    */
    fetch(webhookUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: body
    })
      .then(function () {
        showSuccess(form);
      })
      .catch(function () {
        showError(form);
        if (submit) submit.disabled = false;
      });
  }

  function bind(form) {
    if (form.getAttribute('data-slack-bound') === 'true') return;
    form.setAttribute('data-slack-bound', 'true');
    form.addEventListener('submit', onSubmit);
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-slack-contact-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-slack"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SLACK_HOST = 'hooks.slack.com';

  function fieldValue(form, name) {
    var field = form.elements.namedItem(name);
    if (!field || typeof field.value !== 'string') return '';
    return field.value.trim();
  }

  function escapeSlack(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function isSlackWebhook(url) {
    try {
      var parsed = new URL(url);
      return parsed.protocol === 'https:' && parsed.hostname === SLACK_HOST;
    } catch (error) {
      return false;
    }
  }

  function showSuccess(form) {
    var fields = form.querySelector('[data-slack-fields]');
    var success = form.querySelector('[data-slack-success]');
    if (fields) fields.hidden = true;
    if (success) {
      success.hidden = false;
      var status = success.querySelector('[data-form-status]');
      if (status) status.focus();
    }
  }

  function showError(form) {
    var error = form.querySelector('[data-slack-error]');
    if (error) error.hidden = false;
  }

  function onSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var error = form.querySelector('[data-slack-error]');
    if (error) error.hidden = true;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var honeypot = form.querySelector('[data-slack-honeypot]');
    if (honeypot && honeypot.value) {
      showSuccess(form);
      return;
    }

    var webhookUrl = form.getAttribute('data-webhook-url');
    if (!isSlackWebhook(webhookUrl)) {
      showError(form);
      return;
    }

    var name = fieldValue(form, 'contact[author]');
    var email = fieldValue(form, 'contact[email]');
    var message = fieldValue(form, 'contact[body]').slice(0, 2500);
    var username = form.getAttribute('data-slack-username');
    var text = [
      '*New product request form message*',
      '*Name:* ' + escapeSlack(name),
      '*Email:* ' + escapeSlack(email),
      '*Page:* <' + window.location.href + '|View page>',
      '*Message:*',
      escapeSlack(message)
    ].join('\n');

    var payload = {
      text: 'New contact form message from ' + name,
      unfurl_links: false,
      unfurl_media: false,
      blocks: [
        {
          type: 'section',
          text: { type: 'mrkdwn', text: text }
        }
      ]
    };

    if (username) payload.username = username;

    var body = new URLSearchParams();
    body.set('payload', JSON.stringify(payload));

    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    /*
      Slack incoming webhooks do not send CORS headers. A form-encoded
      payload POST is a simple request, so the browser can send it.
      The response is opaque and a bad webhook still looks successful.
    */
    fetch(webhookUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: body
    })
      .then(function () {
        showSuccess(form);
      })
      .catch(function () {
        showError(form);
        if (submit) submit.disabled = false;
      });
  }

  function bind(form) {
    if (form.getAttribute('data-slack-bound') === 'true') return;
    form.setAttribute('data-slack-bound', 'true');
    form.addEventListener('submit', onSubmit);
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-slack-contact-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
